import { Pipe, PipeTransform } from '@angular/core';

export enum TwitterAvatarSize {
    normal = '_normal',
    bigger = '_bigger',
    original = '',
}

@Pipe({
    name: 'twitterAvatarSize',
    standalone: false
})
export class TwitterAvatarSizePipe implements PipeTransform {

    constructor() {
    }

    transform(
        text: string,
        avatarSize: TwitterAvatarSize
    ): string {
        if  (!text){
            return;
        }
        // Ignore non-twitter urls
        if (text.indexOf('twimg') === -1) {
            return text;
        }

        const originalExtension = text.substring(text.lastIndexOf('.') + 1);
        const linkWithNoModifier = text.substring(0, text.lastIndexOf('.')).replace(/_normal|_bigger/, '');

        return linkWithNoModifier + avatarSize + '.' + originalExtension;
    }
}
